import { useState } from "react";
import { ChevronRight } from "lucide-react";
import classNames from "classnames";

import { Color } from "utils/theme";
import { AlertIcon } from "./alert-icon";
import { AlertDetails } from "./alert-details";
import { FormattedAlert } from "screens/alerts/utils";
import { useTimeAgo } from "hooks/use-time-ago";

interface AlertProps {
  alert: FormattedAlert;
}

export const Alert = ({ alert }: AlertProps) => {
  const [expanded, setExpanded] = useState(false);
  const timeAgo = useTimeAgo(alert.triggerTimestamp);

  return (
    <div className="border-b" style={{ borderColor: Color.Primary[800] }}>
      <button
        onClick={() => setExpanded((prev) => !prev)}
        className={classNames(
          "flex items-center justify-between space-x-4 px-4 py-5 w-full rounded-lg"
        )}
        onPointerDown={(e) => {
          e.currentTarget.style.opacity = "0.6";
        }}
        onPointerUp={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
        onPointerLeave={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
      >
        <div className="flex items-center space-x-4">
          <AlertIcon severity={alert.severity} />
          <p className="text-lg  text-left">{alert.text}</p>
        </div>
        <div className="flex items-center space-x-3">
          <p
            className="text-base flex items-center whitespace-nowrap"
            style={{ color: Color.Primary[400] }}
          >
            {timeAgo}
          </p>
          <ChevronRight
            className={classNames("w-6 h-6 transition-all duration-300", {
              "rotate-90": expanded,
            })}
            style={{ color: Color.Primary[400] }}
          />
        </div>
      </button>
      {expanded && <AlertDetails alert={alert} />}
    </div>
  );
};
